import React, { Component } from "react";
import { connect } from "react-redux";
import {Helmet} from 'react-helmet';
import { Grid, Hidden, Button, Input, Box } from '@material-ui/core';
import { emailRegex, GA_CODE } from '../../config/constants';
import { NotificationManager } from "react-notifications";
import style from "./style";
import { setBecomeChef } from "../../redux/auth";
import { parentContainer } from "../../config/theme";
import Banner from "../../components/Banner";
import Header from "../../components/Header";
import StackCards from "../../components/StackCards";
import CustomCenterDivider from "../../components/CustomCenterDivder/CustomCenterDivider";
import CustomCenterHeader from "../../components/CustomCenterHeader";
import Footer from "../../components/Footer";
import SignUpDrawer from "../../components/SignUpDrawer";
import ReactGA from 'react-ga';

class Landing extends Component {
  state = {
    openSignUpDrawer: false,
    showVideo: true,
    email:'',
    emailErrMsg: "",
    emailErr: false,
  };

  toggleSignUpDrawer = () => {
    /*this.props.history.push({
      pathname: '/sign-up-chef',

      search: `?type=chef`,
      state: { type: "chef" }
    });*/
    this.props.history.push('/sign-up-chef');
  };

  constructor(props) {
    super(props);
    ReactGA.initialize(GA_CODE);
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentDidUpdate(newProps) {
    if (!!this.props.userId) {
      this.props.history.push("/home/dashboard");
    }
  }

  handleInputChange = e => {
    const { name, value } = e.target;
    this.setState({ email: value });
  };

  onSubscribe() {
    const { email } = this.state;
    if (email.trim().length <= 0) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Email is required"
      });
      console.log("emailErrMsg", email);
    } else if (!emailRegex.test(email.trim())) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Invalid Email"
      });
    } else {
      fetch('https://cuisinecrafters.net/apis/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({email, type: 'chef'})
      })
        .then(response => response.json())
        .then(result => {
          this.setState({ errors: false, emailErr: false, emailErrMsg: "Successfully subscribed", email: "", disabled: false, });
          setTimeout(() => this.setState({ emailErrMsg: "" }), 2500);
        })
        .catch(error => {
          this.setState({ errors: false, emailErr: false, emailErrMsg: "", email: "", disabled: false, });
        });
      NotificationManager.info('Subscribed successfully', 'Subscribe', 3000);
      this.setState({ email: '' });
    }


  }

  render() {
    return (
      <div style={parentContainer}>
        <Helmet>
          <title>Personal Chefs Needed | Bring 5-Star Experiences to More People</title>
          <meta name="description" content="Are you a talented personal chef interested in growing your business and connecting with new clients? Find out how Cuisine Crafters can help you reach your goals." />
          <link rel="canonical" href="https://cuisinecrafters.net/chef" />
          <meta name="robots" content="index, follow, max-snippet:-2, max-image-preview: large, max-video-preview:-1" />
        </Helmet>
        <Grid container>
          <Grid item xs={12}>
            <Header history={this.props.history} />
            <Banner type="chef" history={this.props.history} />
          </Grid>

          <div className="page-video-container">
            <h3>Find out if Cuisine Crafters is a fit for you</h3>
            <div className="video-container">
              <video
                controls
                preload
                id="chef-vid"
                poster="/images/chef-video-thumbnail.png"
              >
                <source type="video/mp4" src="https://cc-videos-staging.s3.us-east-2.amazonaws.com/chef-signup.mp4"/>
              </video>
            </div>
          </div>

          <div className="chef-page-container" style={{ backgroundColor: '#fff' }}>
            <div className="chef-page-content">
              <h3>Grow Your In-Home Dining and Catering Service with Ease</h3>
              <p>
                You are committed to bringing premium dining experiences to your client's homes,
                and we want to help you make more money while doing it.
                At <strong>Cuisine Crafters</strong>, we connect highly-skilled chefs
                and home cooks with high-paying clients so you can grow your business.
                Whether you offer catering for special events, an occasional meal, or daily chef services,
                we'll help you find more clients and earn more consistent income with our innovative platform.
                Contact us to learn more or sign up to become one of our featured personal chefs today.
              </p>
            </div>
          </div>

          <div className="chef-page-container" style={{ backgroundColor: '#ff8000' }}>

            <div className="chef-page-content chef-page-content-invert">
              <h3>Provide Unforgettable In-Home Cooking Services and Earn Big</h3>
              <p>
                At Cuisine Crafters, our mission is to make it easier for personal chefs to build a network of recurring in-home dining clients while providing our clients with exceptional cuisine in the comfort of their own homes. When you sign up as a chef or home cook on our platform, our clients will place orders for your services directly through our platform, so you don't have to worry about finding clients, collecting payments or getting reviews after the dining experience is complete. This lets you focus on providing fantastic service while we handle your business's backend.
              </p>
            </div>
          </div>

          <div className="chef-landing-changes">
            <CustomCenterDivider />
          </div>

          <Hidden mdUp>
            <CustomCenterHeader
              text="How Our Personal Chef Platform Works"
              mobile={true}
            />
          </Hidden>
          <Hidden smDown>
            <CustomCenterHeader
              text="How Our Personal Chef Platform Works"
              computer={true}
            />
          </Hidden>

          {/*<Grid item xs={12} style={style.centerGrid}>
            Supercharge your culinary presence with the help of{" "}
            <strong>Cuisine Crafters</strong> and pursue <br />
            your passion for cooking and bringing joy to people.
          </Grid>*/}
          <Grid item xs={12} style={{ margin: "30px 0" }} />
        </Grid>

        <Grid className="landing-container" container direction="row" spacing={32}>
          <Box className="landing-box">
            <StackCards
              chef={true}
              image="/images/earnMoney.webp"
              txtHeader="Sign Up"
              txtSub={
                <div>
                  To get started, simply enter your
                  information, and we'll contact you with the next steps.
                  Once we approve your application,
                  you may begin receiving requests right away.
                </div>
              }
              title="Sign Up"
              alt="Cuisine Crafters - Sign Up"
              step="1"
            />
          </Box>
          <Box className="landing-box">
            <StackCards
              chef={true}
              image="/images/onlinePresence.webp"
              txtHeader="Promote Business"
              txtSub={
                <div>
                  We have dozens of great resources to help you boost your online visibility, add to your portfolio, and get bookings.  This makes it easier than ever to make new connections and get more jobs.
                </div>
              }
              title="Promote Business"
              alt="Cuisine Crafters - Promote Business"
              step="2"
            />
          </Box>
          <Box className="landing-box">
            <StackCards
              chef={true}
              image="/images/buildNetwork.webp"
              txtHeader="Build a Network"
              txtSub={
                <div>
                  With our support, you will gain access to hundreds of clients who are interested in the fine cuisine you offer. This allows you to create new relationships and build a more reliable business while building an online reputation and track record online.
                </div>
              }
              title="Build a Network"
              alt="Cuisine Crafters - Build a Network"
              step="3"
            />
          </Box>
        </Grid>

          <Grid item xs={12} style={{ margin: "100px 0" }} />


          <Hidden mdUp>
            <CustomCenterHeader
              text="Start crafting cuisines today!"
              mobile={true}
            />
          </Hidden>
          <Hidden smDown>
            <CustomCenterHeader
              text="Start crafting cuisines today!"
              computer={true}
            />
          </Hidden>
          <Grid item xs={12} style={style.centerGrid}>
            <Button onClick={this.toggleSignUpDrawer} style={style.getStarted}>
              Get Started
            </Button>
          </Grid>

          <Grid item xs={12} style={{ margin: "100px 0" }} />

        <div className="chef-page-container" style={{ backgroundColor: '#ff8000' }}>

          <div className="chef-page-content chef-page-content-invert" style={{ paddingBottom: 80 }}>
            <h3>Why Choose Cuisine Crafters?</h3>
            <p>
              At Cuisine Crafters, we help support local personal chefs and catering businesses as they grow thriving businesses while offering our clients the best in-home dining options anywhere. We can help you take the stress and overwhelm out of running your business so you can focus on what you do best–-providing out-of-this-world, in-home dining experiences that your clients will love. Contact us today to learn more.
            </p>
          </div>
        </div>

        <div className="chef-page-container" style={{ backgroundColor: '#fff' }}>

          <div className="chef-page-content" style={{ paddingBottom: 80 }}>
            <h3>Partner with a Platform That Is Committed to Your Success</h3>
            <p>
              Are you ready to build a network of recurring clients for your in-home dining or catering business? We are ready to help. Contact us or sign up to become a personal chef for Cuisine Crafters today.
            </p>
          </div>
        </div>

          <Grid item xs={12} style={{ ...style.specialDiv, marginTop: -30}}>
            <Hidden mdUp>
              <CustomCenterHeader text="Dining experience 101" mobile={true} />
            </Hidden>

            <Hidden smDown>
              <CustomCenterHeader
                text="Dining experience 101"
                computer={true}
              />
            </Hidden>

            <Grid item xs={12}>
              Become a professional home cook in just 1 month using the
              <br /> tips provided in the weekly newsletter.
            </Grid>

            <Grid item xs={12} style={{ margin: "30px 0" }} />

            <Grid container>
              <Grid item xs={12} style={style.centerGrid}>
                <Hidden smDown>
                  <Input
                    error={this.state.emailErr}
                    placeholder="Enter email"
                    value={this.state.email}
                    onChange={this.handleInputChange}
                    style={style.subscribeField}
                    disableUnderline={true}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    style={style.subscribeBtn}
                    onClick={this.onSubscribe.bind(this)}
                  >
                    Subscribe
                  </Button>
                </Hidden>
                <Hidden mdUp>
                  <Grid container direction="row" spacing={0}>
                    <Grid item xs={1} sm={4} />
                    <Grid item xs={6} sm={3}>
                      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Input
                          placeholder="Enter email"
                          style={style.subscribeField}
                          disableUnderline={true}
                          error={this.state.emailErr}
                          value={this.state.email}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                      <Grid container style={{justifyContent: 'flex-start'}}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.onSubscribe.bind(this)}
                          style={style.subscribeBtnTablet}
                        >
                          Subscribe
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid item sm={2} />
                  </Grid>
                </Hidden>
              </Grid>
            </Grid>
          </Grid>

          <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    becomeChef: state.auth.becomeChef
  };
};

const LandingPage = connect(mapStateToProps)(Landing);

export default LandingPage;
